import { useEffect, useState, useRef } from 'react';
import { ReactSession } from 'react-client-session';
import { useNavigate } from 'react-router-dom';
ReactSession.setStoreType("localStorage");

const Header = () => {
  const navigate = useNavigate();    
  const [activeItem, setActiveItem] = useState("Dashboard");
  const [openDropdown, setOpenDropdown] = useState(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const toggleSidebarclose = () => {
    setSidebarCollapsed(false);
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
      if (window.innerWidth >= 992) {
        setSidebarCollapsed(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handlelogout = () => {
    ReactSession.set("welbeingId", "0");
    ReactSession.set("welbeingName", "");
    ReactSession.set("welbeingEmail", "");
    navigate("/");
  }

  const handleItemClick = (itemName) => {
    setActiveItem(itemName);
    if (openDropdown === itemName) {
      setOpenDropdown(null);
    } else {
      setOpenDropdown(itemName);
    }
    if (isMobile) {
      setSidebarCollapsed(false);
    }
  };

  const isDropdownOpen = (itemName) => {
    return openDropdown === itemName;
  };

  return (
    <>
      {isMobile && sidebarCollapsed && (
        <div 
          className="sidebar-overlay"
          onClick={toggleSidebarclose}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 999,
          }}
        />
      )}

      <aside 
        className={`left-sidebar ${sidebarCollapsed ? "collapsed-sidebar" : ""}`}
        style={{
          zIndex: 1000,
          position: isMobile ? 'fixed' : 'fixed',
          left: isMobile && !sidebarCollapsed ? '-100%' : '0',
          transition: 'all 0.3s ease',
          width: isMobile ? '250px' : sidebarCollapsed ? '80px' : '250px'
        }}
      >
        <div>
          <div className="brand-logo d-flex align-items-center justify-content-between">
            <a href="/dashboard" className="text-nowrap logo-img">
              <img 
                src="assets/images/logo.png" 
                className={`dark-logo ${sidebarCollapsed && !isMobile ? "collapsed-logo" : ""}`} 
                width={sidebarCollapsed && !isMobile ? "40" : "180"} 
                alt="" 
              />
            </a>
            <div className="close-btn d-lg-none d-block sidebartoggler cursor-pointer" id="sidebarCollapse">
              <i className="ti ti-x fs-8" onClick={(e) => {
                e.stopPropagation();
                toggleSidebarclose();
              }}></i>
            </div>
          </div>
          <nav className="sidebar-nav scroll-sidebar" data-simplebar>
            <ul id="sidebarnav">
              <li className="nav-small-cap">
                <i className="ti ti-dots nav-small-cap-icon fs-4"></i>
                <span className="hide-menu">Home</span>
              </li>
              
              {/* Dashboard */}
              <li className={`sidebar-item ${activeItem === "Dashboard" ? "active" : ""}`}>
                <a 
                  className="sidebar-link" 
                  href="/dashboard" 
                  onClick={() => handleItemClick("Dashboard")}
                  aria-expanded="false"
                >
                  <span className="me-3"><i className="ti ti-layout-dashboard fs-5"></i></span>
                  <span className="hide-menu">Dashboard</span>
                </a>
              </li>
              
              {/* Orders */}
              <li className={`sidebar-item ${activeItem === "Orders" ? "active" : ""}`}>
                <a 
                  className="sidebar-link" 
                  href="/orders" 
                  onClick={() => handleItemClick("Orders")}
                  aria-expanded="false"
                >
                  <span className="me-3"><i className="ti ti-shopping-cart fs-5"></i></span>
                  <span className="hide-menu">Orders</span>
                </a>
              </li>
              
              {/* Whatsapp */}
              <li className={`sidebar-item ${activeItem.startsWith("WhatsApp") ? "active" : ""}`}>
                <a 
                  className={`sidebar-link has-arrow ${isDropdownOpen("WhatsApp") ? "active" : ""}`} 
                  href="#" 
                  aria-expanded={isDropdownOpen("WhatsApp")}
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <span className="me-3"><i className="ti ti-brand-whatsapp fs-5"></i></span>
                  <span className="hide-menu">WhatsApp</span>
                </a>
                <ul aria-expanded={isDropdownOpen("WhatsApp")} className={`collapse ${isDropdownOpen("WhatsApp") ? "show" : ""} first-level`}>
                  <li className="sidebar-item">
                    <a 
                      href="/whatsapp-orders" 
                      className={`sidebar-link ${activeItem === "WhatsApp Orders" ? "active" : ""}`}
                      onClick={() => handleItemClick("WhatsApp Orders")}
                    >
                      <span className="me-3 ms-3"><i className="ti ti-circle fs-1"></i></span>
                      <span className="hide-menu">Orders</span>
                    </a>
                  </li>
                  <li className="sidebar-item">
                    <a 
                      href="/wa-marketing" 
                      className={`sidebar-link ${activeItem === "WhatsApp Marketing" ? "active" : ""}`}
                      onClick={() => handleItemClick("WhatsApp Marketing")}
                    >
                      <span className="me-3 ms-3"><i className="ti ti-circle fs-1"></i></span>
                      <span className="hide-menu">Marketing</span>
                    </a>
                  </li>
                  <li className="sidebar-item">
                    <a 
                      href="Wasend" 
                      className={`sidebar-link ${activeItem === "WhatsApp Messaging" ? "active" : ""}`}
                      onClick={() => handleItemClick("WhatsApp Messaging")}
                    >
                      <span className="me-3 ms-3"><i className="ti ti-circle fs-1"></i></span>
                      <span className="hide-menu">Messaging</span>
                    </a>
                  </li>
                </ul>
              </li>
              
              {/* Products */}
              <li className={`sidebar-item ${activeItem === "Products" ? "active" : ""}`}>
                <a 
                  className="sidebar-link" 
                  href="/products" 
                  onClick={() => handleItemClick("Products")}
                  aria-expanded="false"
                >
                  <span className="me-3"><i className="ti ti-package fs-5"></i></span>
                  <span className="hide-menu">Products</span>
                </a>
              </li>
              
              {/* Category */}
              <li className={`sidebar-item ${activeItem === "Category" ? "active" : ""}`}>
                <a 
                  className="sidebar-link" 
                  href="/category" 
                  onClick={() => handleItemClick("Category")}
                  aria-expanded="false"
                >
                  <span className="me-3"><i className="ti ti-category fs-5"></i></span>
                  <span className="hide-menu">Category</span>
                </a>
              </li>
              
              {/* Customers */}
              <li className={`sidebar-item ${activeItem === "Customers" ? "active" : ""}`}>
                <a 
                  className="sidebar-link" 
                  href="/customers" 
                  onClick={() => handleItemClick("Customers")}
                  aria-expanded="false"
                >
                  <span className="me-3"><i className="ti ti-users fs-5"></i></span>
                  <span className="hide-menu">Customers</span>
                </a>
              </li>
              
              {/* Coupons */}
              <li className={`sidebar-item ${activeItem === "Coupons" ? "active" : ""}`}>
                <a 
                  className="sidebar-link" 
                  href="/coupon" 
                  onClick={() => handleItemClick("Coupons")}
                  aria-expanded="false"
                >
                  <span className="me-3"><i className="ti ti-discount-2 fs-5"></i></span>
                  <span className="hide-menu">Coupons</span>
                </a>
              </li>

              {/* Slider */}
              <li className={`sidebar-item ${activeItem === "Slider" ? "active" : ""}`}>
                <a 
                  className="sidebar-link" 
                  href="/sliders" 
                  onClick={() => handleItemClick("Slider")}
                  aria-expanded="false"
                >
                  <span className="me-3"><i className="ti ti-photo fs-5"></i></span>
                  <span className="hide-menu">Slider</span>
                </a>
              </li>

              {/* aboutpage */}
              <li className={`sidebar-item ${activeItem === "about" ? "active" : ""}`}>
                <a 
                  className="sidebar-link" 
                  href="/about" 
                  onClick={() => handleItemClick("about")}
                  aria-expanded="false"
                >
                  <span className="me-3"><i className="ti ti-photo fs-5"></i></span>
                  <span className="hide-menu">Aboutpage</span>
                </a>
              </li>
              
              {/* HomePage */}
              <li className={`sidebar-item ${activeItem === "HomePage" ? "active" : ""}`}>
                <a 
                  className="sidebar-link" 
                  href="/home" 
                  onClick={() => handleItemClick("HomePage")}
                  aria-expanded="false"
                >
                  <span className="me-3"><i className="ti ti-home fs-5"></i></span>
                  <span className="hide-menu">HomePage</span>
                </a>
              </li>
              
              {/* Customize Bags */}
              <li className={`sidebar-item ${activeItem.startsWith("Customize Bags") ? "active" : ""}`}>
                <a 
                  className={`sidebar-link has-arrow ${isDropdownOpen("Customize Bags") ? "active" : ""}`} 
                  href="#" 
                  aria-expanded={isDropdownOpen("Customize Bags")}
                  onClick={(e) => {
                    e.preventDefault();
                   
                  }}
                >
                  <span className="me-3"><i className="ti ti-shopping-bag fs-5"></i></span>
                  <span className="hide-menu">Customize Bags</span>
                </a>
                <ul aria-expanded={isDropdownOpen("Customize Bags")} className={`collapse ${isDropdownOpen("Customize Bags") ? "show" : ""} first-level`}>
                  <li className="sidebar-item">
                    <a 
                      href="/jute" 
                      className={`sidebar-link ${activeItem === "Customize Bags Jute" ? "active" : ""}`}
                      onClick={() => handleItemClick("Customize Bags Jute")}
                    >
                      <span className="me-3 ms-3"><i className="ti ti-circle fs-1"></i></span>
                      <span className="hide-menu">Jute Bags</span>
                    </a>
                  </li>
                  <li className="sidebar-item">
                    <a 
                      href="/cotton" 
                      className={`sidebar-link ${activeItem === "Customize Bags Cotton" ? "active" : ""}`}
                      onClick={() => handleItemClick("Customize Bags Cotton")}
                    >
                      <span className="me-3 ms-3"><i className="ti ti-circle fs-1"></i></span>
                      <span className="hide-menu">Cotton Bags</span>
                    </a>
                  </li>
                  <li className="sidebar-item">
                    <a 
                      href="/nonwoven" 
                      className={`sidebar-link ${activeItem === "Customize Bags Non Woven" ? "active" : ""}`}
                      onClick={() => handleItemClick("Customize Bags Non Woven")}
                    >
                      <span className="me-3 ms-3"><i className="ti ti-circle fs-1"></i></span>
                      <span className="hide-menu">Non Woven Bags</span>
                    </a>
                  </li>
                </ul>
              </li>
              
              {/* Enquiries */}
              <li className={`sidebar-item ${activeItem.startsWith("Enquiries") ? "active" : ""}`}>
                <a 
                  className={`sidebar-link has-arrow ${isDropdownOpen("Enquiries") ? "active" : ""}`} 
                  href="#" 
                  aria-expanded={isDropdownOpen("Enquiries")}
                  onClick={(e) => {
                    e.preventDefault();
                    handleItemClick("Enquiries");
                  }}
                >
                  <span className="me-3"><i className="ti ti-help fs-5"></i></span>
                  <span className="hide-menu">Enquiries</span>
                </a>
                <ul aria-expanded={isDropdownOpen("Enquiries")} className={`collapse ${isDropdownOpen("Enquiries") ? "show" : ""} first-level`}>
                  <li className="sidebar-item">
                    <a 
                      href="/productenquery" 
                      className={`sidebar-link ${activeItem === "Enquiries Product" ? "active" : ""}`}
                     
                    >
                      <span className="me-3 ms-3"><i className="ti ti-circle fs-1"></i></span>
                      <span className="hide-menu">Product Enquiry</span>
                    </a>
                  </li>
                  <li className="sidebar-item">
                    <a 
                      href="/generalenquery" 
                      className={`sidebar-link ${activeItem === "Enquiries General" ? "active" : ""}`}
                      onClick={() => handleItemClick("Enquiries General")}
                    >
                      <span className="me-3 ms-3"><i className="ti ti-circle fs-1"></i></span>
                      <span className="hide-menu">General Enquiry</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
        </div>
      </aside>


      
            <header className={`app-header ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
  <nav className="navbar navbar-expand-lg navbar-light">
    <div className="d-flex align-items-center w-100">
      {/* Logo - Add your logo here */}
      <div className="d-lg-none navbar-brand me-3">
        <img src="assets/images/logo.png" alt="Logo" height="30" />
      </div>

      {/* Menu Icon (visible on all screens) */}
      <ul className="navbar-nav me-auto">
        <li className="nav-item">
          <a 
            className="nav-link sidebartoggler nav-icon-hover" 
            href="#"
            onClick={(e) => {
              e.preventDefault();
              toggleSidebar();
            }}
          >
            <i className="ti ti-menu-2"></i>
          </a>
        </li>
      </ul>

      {/* Three dots and profile dropdown (aligned to right) */}
      <div className="d-flex align-items-center ms-auto">
        {/* Mobile menu button (three dots) */}
       
        
        {/* Profile dropdown (visible on all screens) */}
        <ul className="navbar-nav">
          <li className="nav-item dropdown">
            <a className="nav-link pe-0" href="" id="drop1" data-bs-toggle="dropdown" aria-expanded="false">
              <div className="d-flex align-items-center" id="profile">
                <div className="user-profile-img">
                  <img src="dist/images/profile/user-1.jpg" className="rounded-circle" width="35" height="35" alt="" />
                </div>
              </div>
            </a>
            <div 
              className="dropdown-menu content-dd dropdown-menu-end dropdown-menu-animate-up" 
              aria-labelledby="drop1"
              ref={dropdownRef}
            >
              <div className="profile-dropdown position-relative" >
                <div className="py-3 px-7 pb-0">
                  <h5 className="mb-0 fs-5 fw-semibold">User Profile</h5>
                </div>
                <div className="d-flex align-items-center py-9 mx-7 border-bottom">
                  <img 
                    src="dist/images/profile/user-1.jpg" 
                    className="rounded-circle" 
                    width="80" 
                    height="80" 
                    alt="User" 
                    onError={(e) => {
                      e.target.src = 'path/to/default/image.jpg';
                    }}
                  />
                  <div className="ms-3">
                    <h5 className="mb-1 fs-3">Admin</h5>
                    <p className="mb-0 d-flex text-dark align-items-center gap-2">
                      <i className="ti ti-mail fs-4"></i> {ReactSession.get("welbeingEmail")}
                    </p>
                  </div>
                </div>
                <div className="message-body">
                  <a href="#" className="py-8 px-7 mt-8 d-flex align-items-center">
                    <span className="d-flex align-items-center justify-content-center bg-light rounded-1 p-6">
                      <img 
                        src="https://demos.adminmart.com/premium/bootstrap/modernize-bootstrap/package/dist/images/svgs/icon-account.svg" 
                        alt="Account" 
                        width="24" 
                        height="24" 
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    </span>
                    <div className="w-75 d-inline-block v-middle ps-3">
                      <h6 className="mb-1 bg-hover-primary fw-semibold">My Profile</h6>
                      <span className="d-block text-dark">Account Settings</span>
                    </div>
                  </a>
                </div>
                <div className="d-grid py-4 px-7 pt-8">
                  <button onClick={handlelogout} className="btn btn-outline-primary">
                    Log Out
                  </button>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    
  </nav>
</header>
      
    </>
  )
}

export default Header;